export default __webpack_public_path__ + "static/media/vicop16.37698cb6.jpg";